import { fmtMin, fmtTime, fmtDT, mins } from "@/lib/format";
import { CheckCircle2, Circle, Loader } from "lucide-react";

const TIMELINE = [
  ["order_received", "Sales Order Received"],
  ["verification", "Order Verification"],
  ["stock_check", "Stock Availability Check"],
  ["reservation", "Stock Reserved"],
  ["picking", "Picking"],
  ["picking_verification", "Picking Verification"],
  ["qc", "QC Verification"],
  ["packing", "Packing"],
  ["documentation", "Documentation"],
  ["vehicle", "Vehicle Check-in"],
  ["loading", "Loading"],
  ["dispatch", "Dispatched"],
  ["pod_in_transit", "In Transit"],
  ["pod_delivered", "Delivered"],
  ["pod_received", "POD Received"],
  ["pod_closed", "Order Closed"],
];

export function OrderTimeline({ stages }) {
  return (
    <div className="bg-card border border-border rounded-lg p-5" data-testid="order-timeline">
      <h2 className="text-xl font-bold uppercase tracking-tight mb-4">Order → Dispatch Timeline</h2>
      <ol className="relative border-l border-border ml-3 space-y-5">
        {TIMELINE.map(([key, label]) => {
          const e = stages[key];
          const done = !!(e?.at || e?.end);
          const active = !done && !!e?.start;
          if (!e && !done) return (
            <li key={key} className="ml-6 opacity-50" data-testid={`timeline-${key}`}>
              <span className="absolute -left-3 w-6 h-6 rounded-full bg-muted text-muted-foreground flex items-center justify-center"><Circle className="w-4 h-4" /></span>
              <p className="font-medium text-sm">{label}</p>
            </li>
          );
          const dur = e?.start && e?.end ? mins(e.start, e.end) : null;
          return (
            <li key={key} className="ml-6" data-testid={`timeline-${key}`}>
              <span className={`absolute -left-3 w-6 h-6 rounded-full flex items-center justify-center ${done ? "bg-signal-green/20 text-signal-green" : "bg-signal-amber/20 text-signal-amber"}`}>
                {done ? <CheckCircle2 className="w-4 h-4" /> : <Loader className="w-4 h-4 animate-spin" />}
              </span>
              <div className="flex flex-wrap items-center gap-x-3">
                <p className="font-semibold text-sm">{label}</p>
                {dur != null && <span className="metric text-sm text-primary font-bold">{fmtMin(dur)}</span>}
              </div>
              <div className="text-xs text-muted-foreground metric space-x-3">
                {e?.at && <span>{fmtDT(e.at)}</span>}
                {e?.start && <span>{fmtTime(e.start)} → {e.end ? fmtTime(e.end) : "…"}</span>}
                {e?.by && <span className="font-sans">by {e.by}</span>}
                {e?.workers?.length > 0 && <span className="font-sans">workers: {e.workers.join(", ")}</span>}
                {e?.delay_reason && <span className="font-sans text-signal-red">delay: {e.delay_reason}</span>}
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
